import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ClientSideRowModelModule } from "ag-grid-community";
import { ModuleRegistry } from "ag-grid-community";
import { useSelector, useDispatch } from "react-redux";
import {
    getMedicationatDashboard,
    getLabResultatDashboard,
    getVitals,
    getAllMRSItesReports,
    getLogUserMenuAnalytics,
    getgridHeaders

} from "apiServices/reducer/apiService";
import { AddVitals } from "pageComponents";
import { CTGrid } from "../../components";
import {
    Image as ImageIcon,
    Droplet,
    Heart,
    FileText
} from 'lucide-react';
import ViewSharedReports from './viewsharedreports';


// Custom tooltip styles
const customTooltipStyles = `
    .custom-tooltip {
        background-color: #2c3e50 !important;
        color: white !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        border: none !important;
        max-width: 200px !important;
        text-align: center !important;
        opacity: 0.95 !important;
        transition: opacity 0.3s ease-in-out !important;
    }

    .custom-tooltip .tooltip-arrow {
        border-color: #2c3e50 !important;
    }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = customTooltipStyles;
document.head.appendChild(styleSheet);

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const AccessDashboard = (props) => {

    const [activeTab, setActiveTab] = useState(props.tab || "All");
    const [searchQuery, setSearchQuery] = useState("");
    const [isFullscreen, setIsFullscreen] = useState(false); // State for fullscreen mode

    // Add state for date range picker
    const dispatch = useDispatch()
    const token = useSelector((state) => state.apiService.token);
    const MenuData = useSelector((state) => state.apiService.menuItem);
    const FamilyData = useSelector((state) => state.apiService.familyAccounts);
    const userData = useSelector((state) => state.apiService.login);
    // console.log(userData, "token");
    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
    console.log(menuData, "AccessDashboard menuData")
    const categoryData = useSelector((state) => state.apiService.login.categories);
    console.log(categoryData, "categoryData")
    const isAccess = menuData.role === 'User';
    const [isProvider, setIsProvider] = useState(false);
    console.log(isAccess, "isAccess")
    useEffect(() => {
        if (!isAccess && userData) {
            setIsProvider(userData.user_type_name === 'Provider');
        } else {
            setIsProvider(false);
        }

        dispatch(getgridHeaders(params)).then((response) => {
            console.log("Response from getgridHeaders:", response);
        });
    }, [isAccess, userData]);

    const params = {
        token: isAccess ? menuData.Token : token,
        user_id: isAccess ? menuData.user_id : (isProvider && userData ? props.userID : (userData?.user_id || ''))
    };
    const userId = menuData?.user_id;
    const isExternalUser = menuData?.is_external_user || false;
    const accessType = menuData?.access_type || 'shared';

    const [showReport, setShowReport] = useState(false);
    const [showDashboard, setShowDashBoard] = useState(true);
    const [showViewSharedReports, setShowViewSharedReports] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [PDFURL, setPDFURL] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [rowData, setRowData] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);

    const [rowDatanew, setRowDatanew] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);

    const menuItems = categoryData.map(category => {
        if (category.category_id === 2 || category.category_id === 3 || category.category_id === 4 || category.category_id === 9) {
            return {
                label: category.category_name,
                icon: <ImageIcon className="pmr-menu-icon" />,
                color: "#e0f2fe",
                id: category.category_id,
                parent_id: 2
            }
        } else {
            return null;
        }
    });
    console.log(menuItems, "menuItems")
    useEffect(() => {
        // console.log(categoryData, "categoryData")
        // const formattedData = categoryData.map(category => {
        //     return {
        //     label: category.name,
        //     icon: <ImageIcon className="pmr-menu-icon" />,
        //     color: "#e0f2fe",
        //     id: category.id,
        //     parent_id: category.parent_id
        // }});
        // console.log(formattedData, "formattedData")

    }, [categoryData])

    const [showModal, setShowModal] = useState(false);
    const [medications, setMedicationData] = useState([]);
    const [labResults, setLabResults] = useState([

    ]);
    const handleAddClick = () => {
        setShowModal(true); // Show the modal when "Add" is clicked
    };

    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: '',
        ProviderName: '',
        HospitalName: '',
        UserID: userId,
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: isAccess ? menuData.Token : token
    });

    const [logUserMenuAnalyticsData, setLogUserMenuAnalyticsData] = useState({
        MenuID: 3,
        ParentID: 2,
        UserID: 5,
        token: isAccess ? menuData.Token : token
    });

    const [vitalsValues, setVitalsValues] = useState({
        BloodPressure: "",
        HeartRate: "",
        BloodSugar: "",
        Weight: "",
        WaistSize: "",
    });

    // const setLogUserMenuAnalytics = (event, boolean) => {
    //     console.log(event, "event at setLogUserMenuAnalytics")
    //     const tab = boolean ? event.group_name : event.label;

    //     // Navigate to ViewSharedReports component
    //     setSelectedCategory(tab);
    //     setShowDashBoard(false);
    //     // Log analytics
    //     dispatch(getLogUserMenuAnalytics({
    //         MenuID: event.id || 3,
    //         ParentID: event.parent_id || 2,
    //         UserID: isAccess ? menuData.user_id : userId,
    //         token: isAccess ? menuData.Token : token
    //     })).then((response) => {
    //         console.log("Response from getLogUserMenuAnalytics:", response);
    //     });

    //     setActiveTab(tab);
    //     setSearchQuery("")
    //     setSelectedRow(null)
    //     setRowData([]);
    //     setRowDatanew([])
    //     setPDFURL(null)
    //     console.log(event, "event")

    //     if (props.activeMenuItem && props.activeMenuItem.showAccessDashboard === true) {
    //         props.activeMenuItem.showAccessViewSharedReports = true;
    //         props.activeMenuItem.showAccessDashboard = false;
    //         setActiveTab(tab)
    //         console.log(props.activeMenuItem, "props.activeMenuItem1")
    //     }
    //     else if (props.activeMenuItem && props.activeMenuItem.showAccessViewSharedReports === true && isProvider) {
    //         props.activeMenuItem.showAccessViewSharedReports = false;
    //         props.activeMenuItem.showAccessDashboard = true;
    //         setActiveTab(tab)
    //         console.log(props.activeMenuItem, "props.activeMenuItem2")
    //     }

    //     const activeTabData = {
    //         menu_id: 2,
    //         parent_id: 2,
    //     }

    //     if (props.onViewReportsClick) {
    //         props.onViewReportsClick(activeTabData);
    //     }

    //     setStartDate(null);
    //     setEndDate(null);
    //     setViewReportData({
    //         ReportGroupName: "",
    //         ProviderName: "",
    //         user_id: userId,  // Changed from UserID to user_id
    //         HospitalName: "",
    //         SearchKey: searchQuery,
    //         ReportDateStart: null,
    //         ReportDateEnd: null,
    //         token: token
    //     })

    //     if (boolean) {
    //         getReportPerId(event.report_id)
    //     }
    // }

    // const fetchReportsData = (tab) => {
    //     const reportData = {
    //         ReportGroupName: tab || "",
    //         ProviderName: "",
    //         user_id: isAccess ? menuData.user_id : userId,
    //         HospitalName: "",
    //         SearchKey: searchQuery,
    //         ReportDateStart: startDate,
    //         ReportDateEnd: endDate,
    //         token: isAccess ? menuData.Token : token
    //     };

    //     dispatch(getAllMRSItesReports(reportData)).then((resp) => {
    //         const fetchedData = resp.payload.Table || [];

    //         if (fetchedData.length > 0) {
    //             // Filter data by tab if specified
    //             const filteredData = tab ? fetchedData.filter(report => report.group_name === tab) : fetchedData;

    //             const formattedData = filteredData.map(report => ({
    //                 name: report.report_name,
    //                 date: report.report_date,
    //                 category: report.group_name,
    //                 clinic: report.hospital_name,
    //                 url: report.report_path,
    //                 reportId: report.report_id
    //             }));

    //             setRowData(formattedData);
    //             setRowDatanew(formattedData);
    //         } else {
    //             setRowData([]);
    //             setRowDatanew([]);
    //         }
    //     }).catch(error => {
    //         console.error("Error fetching reports data:", error);
    //         setRowData([]);
    //         setRowDatanew([]);
    //     });
    // };

    // const getReportPerId = (reportId) => {
    //     if (!reportId) return;

    //     // This function fetches a specific report by its ID
    //     // You may need to implement the actual API call based on your backend endpoints
    //     const reportParams = {
    //         report_id: reportId,
    //         user_id: isAccess ? menuData.user_id : userId,
    //         token: isAccess ? menuData.Token : token
    //     };

    //     console.log("Fetching report with ID:", reportId, reportParams);

    //     // Placeholder implementation - replace with actual API call
    //     // dispatch(getReportById(reportParams)).then((response) => {
    //     //     if (response.payload) {
    //     //         // Handle the specific report data
    //     //         console.log("Report data:", response.payload);
    //     //         setPDFURL(response.payload.report_path || null);
    //     //     }
    //     // }).catch(error => {
    //     //     console.error("Error fetching report by ID:", error);
    //     // });
    // };

    const medColumns = [
        {
            headerName: "Medication",
            field: "medication",
            headerTooltip: "Medication",
            tooltipValueGetter: (params) => {
                const medication = params.value || "N/A";
                const dose = params.data?.dose || "";
                return dose ? `${medication} (${dose})` : medication;
            },
            cellRenderer: (params) => {
                const medication = params.value || "N/A";
                const dose = params.data?.dose || "";
                const displayText = dose ? `${medication} (${dose})` : medication;
                return (
                    <div
                        style={{
                            fontSize: "12px",
                            color: "gray",
                            fontWeight: "500",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {displayText}
                    </div>
                );
            },
        },
        {
            headerName: "Frequency",
            field: "frequency",
            headerTooltip: "Frequency",
            tooltipValueGetter: (params) => params.value || "N/A",
            cellRenderer: (params) => {
                const frequency = params.value || "N/A";
                return (
                    <div
                        style={{
                            fontSize: "12px",
                            color: "gray",
                            fontWeight: "500",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {frequency}
                    </div>
                );
            },
        },
    ];

    const labColumns = [
        {
            headerName: "Report Name",
            field: "name",
            flex: 1,
            headerTooltip: "Report Name",
            tooltipField: "name",
            wrapText: true,
            autoHeight: true,
            cellClass: 'lab-report-name-wrap ag-cell-wrap-text',
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                lineHeight: "1.6",
            },
            cellRenderer: (params) => {
                const name = params.value || "N/A";
                return (
                    <div
                        style={{
                            fontSize: "12px",
                            color: "gray",
                            fontWeight: "500",
                            textDecoration: "underline",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            lineHeight: "1.4",
                            width: "100%",
                        }}
                    >
                        {name}
                    </div>
                );
            },
        },
        {
            headerName: "Report Date",
            field: "date",
            headerTooltip: "Report Date",
            tooltipField: "date",
            cellRenderer: (params) => {
                const date = params.value || "N/A";
                return (
                    <div
                        style={{
                            fontSize: "12px",
                            color: "gray",
                            fontWeight: "500",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {date}
                    </div>
                );
            },
        },
    ];

    const handleAddVitals = () => {
        // Handle adding vitals
    };

    const [seriesData, setSeriesData] = useState([
        { name: 'Systolic', data: [] },
        { name: 'Diastolic', data: [] },
    ]);

    const [seriesDataforHeartRate, setHeartRateData] = useState([
        { name: 'Heart Rate', data: [] },
    ]);

    const [seriesDataforBloodSugar, setBloodSugarData] = useState([
        { name: 'Blood Sugar', data: [] },])

    const [seriesDataforWeight, setWeightData] = useState([
        { name: 'Weight', data: [] },])

    const [seriesDataforWaistSize, setWaistSizeData] = useState([
        { name: 'Waist Size', data: [] },])


    useEffect(() => {
        console.log(props.isFromDetails, "props.isFromDetails")

        if (props.isFromReports) {
            console.log(viewReportData, "viewReportData112233")
            dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                const fetchedData = resp.payload.Table;


                console.log(rowData, "formattedData")
                if (fetchedData.length > 0) {
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedDatanew);
                    setRowDatanew(formattedDatanew);


                }


                // // Use fetched data directly
                // const filteredData = fetchedData.filter(report => report.group_name === event.title);
                // const formattedData = filteredData.map(report => ({
                //     name: report.report_name,
                //     date: report.report_date,
                //     category: report.group_name,
                //     clinic: report.hospital_name,
                //     url: report.report_path,
                //     reportId: report.report_id
                // }));
                // setRowData(formattedData);
                // setRowDatanew(formattedData);


            });

        }


        // dispatch(getgridHeaders(params)).then((response) => {
        //     console.log("Response from getgridHeaders:", response);
        //     setGridHeaers(response.payload || []);
        //     const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
        //         name: report.name,
        //         id: report.id
        //     }));
        //     setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
        // });

        dispatch(getLogUserMenuAnalytics(logUserMenuAnalyticsData)).then((response) => {
            console.log("Response from getLogUserMenuAnalytics:", response + logUserMenuAnalyticsData);
        });

        console.log(props.userID, "props.userID")
        // Fetch medications
        dispatch(getMedicationatDashboard({
            token: isAccess ? menuData.Token : token,
            user_id: isAccess ? menuData.user_id : userId
        })).then((response) => {
            console.log("Full medication response:", response);
            const rawData = response.payload?.Table || [];
            console.log("Raw Medication Data:", rawData);

            if (!Array.isArray(rawData)) {
                console.error("Expected medication data to be an array but got:", rawData);
                return;
            }

            const formattedData = rawData.map((medication) => ({
                MedicationName: medication.medication_name || medication.medication || '',
                Dose: medication.medication_dose || medication.dose || '',
                MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                MedicationStartedFrom: medication.medication_started_from || medication.startedFrom
                    ? new Date(medication.medication_started_from || medication.startedFrom)
                    : new Date(),
                MedicationComments: medication.medication_comments || medication.comments || '',
                Status: medication.medication_status || medication.status || 'Active',

                // Raw backend values for grid display
                medication: medication.medication_name || medication.medication || '',
                dose: medication.medication_dose || medication.dose || '',
                frequency: medication.medication_recurrence || medication.frequency || '',
                startedFrom: medication.medication_started_from || medication.startedFrom || '',
                comments: medication.medication_comments || medication.comments || '',
                status: medication.medication_status || medication.status || 'Active'
            }));

            console.log("Formatted medication data:", formattedData);
            setMedicationData(formattedData);
        }).catch(error => {
            console.error("Error fetching medications:", error);
        });
        const labdata = {
            user_id: isAccess ? menuData.user_id : userId,
            token: isAccess ? menuData.Token : token
        }
        console.log(labdata, "labdata")
        // Filter and display only Blood work reports from sharedReportsValidateCode
        if (menuData && menuData.reports && Array.isArray(menuData.reports)) {
            console.log("Filtering Blood work reports from menuData:", menuData.reports);

            // Filter reports where group_name is "Blood work"
            const bloodWorkReports = menuData.reports.filter(report =>
                report.group_name === "Blood work"
            );

            console.log("Filtered Blood work reports:", bloodWorkReports);

            if (bloodWorkReports.length > 0) {
                const formattedData = bloodWorkReports.map(labResult => ({
                    name: labResult.report_name,
                    date: labResult.report_date,
                    label: labResult.group_name,
                    reportId: labResult.report_id,
                }));
                setLabResults(formattedData);
            } else {
                // No Blood work reports found
                setLabResults([]);
            }
        } else {
            // Fallback to original API call if menuData.reports is not available
            dispatch(getLabResultatDashboard(labdata)).then((response) => {
                console.log("Response from getLabResultatDashboard:", response.payload);
                if (response.payload != undefined) {
                    const labResultData = response.payload;
                    const formattedData = labResultData.map(labResult => ({
                        name: labResult.report_name,
                        date: labResult.report_date,
                        label: labResult.group_name,
                        reportId: labResult.report_id,
                    }));
                    setLabResults(formattedData);
                }
            });
        }

        dispatch(getVitals(labdata)).then((response) => {
            const vitalsData = response.payload || [];
            console.log("vitalsDatanew", vitalsData);

            const systolicData = [];
            const diastolicData = [];
            const heartRateData = [];
            const bloodSugarData = [];
            const weightData = [];
            const waistSizeData = [];

            vitalsData.forEach(vital => {
                if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                    systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                    diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                }
                if (vital.LastUpdated && vital.HeartRate) {
                    heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                }
                if (vital.LastUpdated && vital.BloodSugar) {
                    bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                }
                if (vital.LastUpdated && vital.Weight) {
                    weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                }
                if (vital.LastUpdated && vital.WaistSize) {
                    waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                }
            });

            setSeriesData([
                { name: 'Systolic', data: systolicData },
                { name: 'Diastolic', data: diastolicData },
            ]);
            setHeartRateData([
                { name: 'Heart Rate', data: heartRateData },
            ]);
            setBloodSugarData([
                { name: 'Blood Sugar', data: bloodSugarData },
            ]);
            setWeightData([
                { name: 'Weight', data: weightData },
            ]);
            setWaistSizeData([
                { name: 'Waist Size', data: waistSizeData },
            ]);

            const latestVital = vitalsData[vitalsData.length - 1] || {};
            setVitalsValues({
                BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                    ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                    : "N/A",
                HeartRate: latestVital.HeartRate || "N/A",
                BloodSugar: latestVital.BloodSugar || "N/A",
                Weight: latestVital.Weight || "N/A",
                WaistSize: latestVital.WaistSize || "N/A",
            });
        });



        // Re-implement fullscreen listener setup
        const handleFullscreenChange = () => {
            console.log("Fullscreen change detected. Is fullscreen:", !!document.fullscreenElement);
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
        document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
        document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge

        // Cleanup listener on component unmount
        return () => {
            console.log("Cleaning up fullscreen listener.");
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge
        };
    }, [showDashboard, dispatch, token, logUserMenuAnalyticsData, MenuData, FamilyData, props.isFromDetails, props.isFromReports, props.activeMenuItem]); // Add necessary dependencies if they affect the setup

    const [draggedWidget, setDraggedWidget] = useState(null);
    const [widgetPositions, setWidgetPositions] = useState({
        medications: { order: 0, col: 'col-md-3' },
        labResults: { order: 1, col: 'col-md-3' },
        vitals: { order: 2, col: 'col-md-6' }
    });

    const handleWidgetDragStart = (e, widgetType) => {
        e.dataTransfer.setData("widgetType", widgetType);
        setDraggedWidget(widgetType);
        // Add visual feedback
        e.currentTarget.style.opacity = "0.5";
    };

    const handleWidgetDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "2px dashed var(--pmr-secondary)";
    };

    const handleWidgetDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
    };

    const handleWidgetDrop = (e, targetWidgetType) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
        e.currentTarget.style.opacity = "1";

        if (draggedWidget && draggedWidget !== targetWidgetType) {
            // Get current positions
            const draggedPos = widgetPositions[draggedWidget];
            const targetPos = widgetPositions[targetWidgetType];

            // Swap positions
            setWidgetPositions(prev => ({
                ...prev,
                [draggedWidget]: { ...prev[draggedWidget], order: targetPos.order },
                [targetWidgetType]: { ...prev[targetWidgetType], order: draggedPos.order }
            }));
        }

        setDraggedWidget(null);
    };


    const hasBloodWork = categoryData &&
        categoryData.some(category =>
            category.category_name.toLowerCase().includes('blood work')
        );

    const handleWidgetDragEnd = (e) => {
        e.currentTarget.style.opacity = "1";
    };

    // Sort widgets based on their order
    const getSortedWidgets = () => {
        const allWidgets = Object.entries(widgetPositions)
            .sort(([, a], [, b]) => a.order - b.order)
            .map(([type]) => type);

        // If isAccess is true, only return medication, labResults, and vitals
        if (isAccess) {
            return allWidgets.filter(widget =>
                ['medications', 'labResults', 'vitals'].includes(widget)
            );
        }

        return allWidgets;
    };



    // Conditional rendering based on current view
    if (showViewSharedReports) {
        return (
            <div style={{ backgroundColor: "#ffffff" }} >
                <div className="row">
                    <div className="col-12">
                        <ViewSharedReports
                            setShowViewSharedReports={setShowViewSharedReports}
                            token={token}
                            userId={userId}
                            isExternalUser={isExternalUser}
                            accessType={accessType}
                            isAccess={isAccess}
                            selectedCategory={selectedCategory}
                            activeTabfromUserAnalytics={selectedCategory}
                            setShowDashBoard={setShowDashBoard}
                            setSelectedCategory={setSelectedCategory}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div style={{ backgroundColor: "#ffffff" }}>
                <div className="container-fluid mt-0 margin-0">
                    <>
                        <div className="text-start d-flex justify-content-center align-items-center gap-4 iconMargin p-0">
                            <div className="menu-row">
                                {menuItems.map((item, index) => (
                                    item && (
                                        <div
                                            key={index}
                                            className="menu-card"
                                            onClick={() => props.setLogUserMenuAnalytics(item, false)}
                                        >
                                            <span className="menu-icon-bg">
                                                {item.icon}
                                            </span>
                                            <p className="menu-label">{item.label}</p>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>

                        <div className="row p-0 medicationContainer">
                            {getSortedWidgets().map((widgetType) => {
                                if (isAccess && !['medications', 'labResults', 'vitals'].includes(widgetType)) {
                                    return null;
                                }
                                switch (widgetType) {
                                    case 'medications':
                                        return (
                                            <div
                                                key="medications"
                                                className={widgetPositions.medications.col}
                                                draggable={!isAccess}
                                                onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'medications')}
                                                onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                onDrop={(e) => !isAccess && handleWidgetDrop(e, 'medications')}
                                                onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                            // style={{ cursor: isAccess ? 'default' : 'move' }}
                                            >
                                                <div className="card shadow-lg p-0" style={{ minHeight: '350px' }}>
                                                    <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG">
                                                        <h6 className="mb-0 text-capitalize">Medications</h6>
                                                    </div>
                                                    <div className="card-body p-0">
                                                        <CTGrid
                                                            rowData={medications}
                                                            columnDefs={medColumns}
                                                            onAddEditable={!isAccess ? "Add/Edit Medications" : undefined}
                                                            onAddEdit={!isAccess}
                                                            label={!isAccess ? "Add/Edit" : undefined}
                                                            height={250}
                                                            disablePagination={true}
                                                        />
                                                    </div>
                                                    {!isProvider && !isAccess && (
                                                        <div className="card-footer text-start d-flex p-x4">
                                                            <span variant="text" className="modalfooterclickeventtext cursor-pointer" onClick={handleAddClick}>Add</span>
                                                            <span className="mx-2 text-muted">|</span>
                                                            <span variant="text" className="modalfooterclickeventtext cursor-pointer" >Edit</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );

                                    case 'labResults':
                                        return (

                                            <div
                                                key="labResults"
                                                className={widgetPositions.labResults.col}
                                                draggable={!isAccess}
                                                onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'labResults')}
                                                onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                onDrop={(e) => !isAccess && handleWidgetDrop(e, 'labResults')}
                                                onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                            // style={{ cursor: isAccess ? 'default' : 'move' }}
                                            >
                                                <div className="card shadow-lg p-0" style={{ minHeight: '350px' }}>
                                                    <div className="card-header mb-0 d-flex justify-content-between align-items-center cardwidgehtHeaderBG">
                                                        <h6 className="mb-0 text-capitalize">Lab Results</h6>
                                                    </div>
                                                    {hasBloodWork ? (
                                                        <div className="card-body p-0" style={isProvider ? { height: '180px', minHeight: '180px', maxHeight: '180px' } : { height: '200px', minHeight: '200px', maxHeight: '200px' }}>
                                                            <CTGrid rowData={labResults} columnDefs={labColumns} height={250} onRowClickforLabResults={(event) => props.setLogUserMenuAnalytics(event, true)} disablePagination={true}
                                                                tooltipShowDelay={0} />
                                                        </div>
                                                    ) : (
                                                        <div className="card-body d-flex align-items-center justify-content-center align-content-center h-100">
                                                            <p className="text-danger fs-7 fw-bold">No reports to show</p>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                        );

                                    case 'vitals':
                                        return (
                                            <div
                                                key="vitals"
                                                className={widgetPositions.vitals.col}
                                                draggable={!isAccess}
                                                onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'vitals')}
                                                onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                onDrop={(e) => !isAccess && handleWidgetDrop(e, 'vitals')}
                                                onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}

                                            // style={{ cursor: isAccess ? 'default' : 'move' }}
                                            >
                                                <AddVitals
                                                    header="Vitals"
                                                    title="Blood Pressure"
                                                    height={160}
                                                    seriesData={seriesData}
                                                    BloodPressure={vitalsValues.BloodPressure}
                                                    heartRate={vitalsValues.HeartRate}
                                                    Bloodsugar={vitalsValues.BloodSugar}
                                                    weight={vitalsValues.Weight}
                                                    waist={vitalsValues.WaistSize}
                                                    type="area"
                                                    heartRateData={seriesDataforHeartRate}
                                                    bloodSugarData={seriesDataforBloodSugar}
                                                    waistData={seriesDataforWaistSize}
                                                    weightData={seriesDataforWeight}
                                                    onClickHandler={!isAccess ? () => handleAddVitals(vitalsValues) : undefined}
                                                    Bpheader="Blood Pressure"
                                                    heartRateheader="Heart Rate"
                                                    bloodSugarDataheader="Blood Sugar"
                                                    wieghtDataheader="Weight"
                                                    waistheader="Waist Size"
                                                    userId={userId}
                                                    isFromUserLandingPage={isAccess ? false : true}
                                                    selectedFamilyMember={props.selectedFamilyMember}
                                                />
                                            </div>
                                        );

                                    default:
                                        return null;
                                }
                            })
                            }
                        </div>
                    </>
                    {/* </div> */}
                </div>
            </div >
        </>
    )
}

export default AccessDashboard;